import React from 'react';
import './App.css';
import Fetch from './components/Fetch';

function App() {
  return (
    <div className="App">
      <Fetch/>
    </div>
  );
}

export default App;
